
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gaweb-unidays',
    templateUrl: './unidays.component.html'
})
export class UniDaysComponent implements OnInit {
    constructor(
            ) { }

    ngOnInit(): void {
    }
}



// WEBPACK FOOTER //
// ./src/app/third-party/UniDays/unidays.component.ts